import { ActionIcon, Button, Code, Collapse, Container, Group, Stack, Title } from "@mantine/core";
import { randomId, useClipboard, useDisclosure } from "@mantine/hooks";
import { IconCheck, IconCopy, IconExclamationCircle } from "@tabler/icons-react";
import { ErrorComponentProps } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import classes from "shared/components/global/AppError/AppError.module.css";
import { useOIDCStore } from "shared/stores/oidc";
import { logger } from "shared/utils/logger";
import { maybe } from "shared/utils/maybe";

function createStackId() {
    return randomId(useOIDCStore.getState().config.authority.split("/").at(-1) + "-").toUpperCase();
}

export const AppError = (props: ErrorComponentProps) => {
    const [id, setId] = useState<string>();
    const [opened, { toggle }] = useDisclosure();
    const clipboard = useClipboard();

    useEffect(() => {
        if (!id) return;
        logger.error(`[${id}] ${props.error.toString()}`);
        maybe(props.error.stack)?.take((it) => logger.error(`[${id}] [stack] ${it}`));
    }, [id]);

    useEffect(() => {
        setId(createStackId());
    }, [props.error.stack]);

    return (
        <Container h="100%">
            <Stack h="80%" justify="space-evenly" align="center" w="100%">
                <div className={classes.label}></div>
                <IconExclamationCircle size={220} />
                <Title fz={"2rem"} ta="center">
                    An unexpected error has occured
                </Title>
                <Group justify="center">
                    <Button variant="default" size="md" onClick={() => (window.location.href = "/")}>
                        Home
                    </Button>
                    <Button variant="default" size="md" onClick={() => (window.location.href = "/logout")}>
                        Logout
                    </Button>
                    <Button variant="default" size="md" onClick={() => window.location.reload()}>
                        Refresh
                    </Button>
                </Group>
                <Button mx="auto" variant="transparent" td="underline" onClick={toggle}>
                    Error Details
                </Button>
            </Stack>

            <Collapse in={opened} flex="1">
                <Code block w="100%" color="background" c="red.8" fw="bold" pos="relative">
                    <ActionIcon
                        variant="transparent"
                        pos="absolute"
                        style={{ right: 8, color: "var(--mantine-color-text)" }}
                        onClick={() => clipboard.copy(id)}
                        aria-label="Copy id"
                    >
                        {clipboard.copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
                    </ActionIcon>
                    {props.error.name + "\n"}
                    {props.error.message + "\n---\n"}
                    stack-id: {id}
                </Code>
            </Collapse>
        </Container>
    );
};
